import { render, staticRenderFns } from "./LedgersTable.vue?vue&type=template&id=9d9f8d90&scoped=true"
import script from "./LedgersTable.vue?vue&type=script&lang=js"
export * from "./LedgersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9f8d90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d9f8d90')) {
      api.createRecord('9d9f8d90', component.options)
    } else {
      api.reload('9d9f8d90', component.options)
    }
    module.hot.accept("./LedgersTable.vue?vue&type=template&id=9d9f8d90&scoped=true", function () {
      api.rerender('9d9f8d90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Dashboard/LedgersTable.vue"
export default component.exports